module.exports = __webpack_public_path__ + "img/swiper__img2.20b5c1ca.svg";